import { useId } from "react"
import { ViewListOutlined } from "@mui/icons-material"
import { Box, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material"
import { readOnlyLabel } from "resources/ai-settings"
import { BODY_SX, CARD_SX, CONTROL_SX, HEADER_SX, MUTED_SX, TEXT_SX, TITLE_SX } from "./card-styles"

export interface OmegaPointAccessCardProps {
  readOnly: boolean
  isSaving: boolean
  onChange: (to: boolean) => void
}

export function OmegaPointAccessCard({ readOnly, isSaving, onChange }: OmegaPointAccessCardProps) {
  const labelId = useId()

  return (
    <Box sx={CARD_SX} data-testid="omega-point-access-card">
      <Box sx={HEADER_SX}>
        <ViewListOutlined fontSize="small" />
        <Typography component="h3" variant="subtitle1" sx={TITLE_SX}>Omega Point Data</Typography>
      </Box>
      <Box sx={BODY_SX}>
        <Box sx={TEXT_SX}>
          <Typography id={labelId} variant="body1" sx={TITLE_SX}>Omega Point tools and API</Typography>
          <Typography variant="body2" sx={MUTED_SX}>
            Read only means Kelly can look but never change anything. Read and write also lets it create, edit, and delete resources on your behalf.
          </Typography>
        </Box>
        <ToggleButtonGroup
          exclusive
          size="small"
          value={readOnly}
          // Not `disabled`: disabling the focused pill drops keyboard focus out of the dock.
          aria-busy={isSaving}
          aria-labelledby={labelId}
          sx={CONTROL_SX}
          // An exclusive group reports null when the selected option is clicked again: nothing to save.
          onChange={(_, to: boolean | null) => { if (to !== null && !isSaving) onChange(to) }}
        >
          <ToggleButton value>{readOnlyLabel(true)}</ToggleButton>
          <ToggleButton value={false}>{readOnlyLabel(false)}</ToggleButton>
        </ToggleButtonGroup>
      </Box>
    </Box>
  )
}
